import React, { Component } from 'react';

export default class Loading extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        //Should get parent height
        let height = '100%';
        if (this.props.full_height) {
            height = `${window.innerHeight}px`;
        }

        let loading_image = (
            <div>
                <div
                    className="spinner-grow text-info"
                    role="status"
                    style={{ margin: '10px' }}
                ></div>

                <div
                    className="spinner-grow text-info"
                    role="status"
                    style={{
                        animationDelay: '150ms',
                        margin: '10px',
                    }}
                ></div>

                <div
                    className="spinner-grow text-info"
                    role="status"
                    style={{
                        animationDelay: '300ms',
                        margin: '10px',
                    }}
                ></div>
            </div>
        );

        if (this.props.loaded) {
            return (
                <div style={{ position: 'relative' }}>
                    {this.props.children}
                </div>
            );
        } else if (this.props.cover) {
            return (
                <div style={{ position: 'relative' }}>
                    {this.props.children}
                    <div
                        style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: height,
                            textAlign: 'center',
                            zIndex: '10',

                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '2% 0%',
                        }}
                    >
                        {loading_image}
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: height,
                        textAlign: 'center',
                        zIndex: '10',
                        padding: '2% 0%',
                    }}
                >
                    {loading_image}
                </div>
            );
        }
    }
}
